export default __webpack_public_path__ + "static/sm-poster9-abca14db2e34186fc28dec954b0afe1b.png";